// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3YPGY","colBig":"styles_colBig__3c7oG","colSmall":"styles_colSmall__2D_Ic"};